import {ApolloLink} from '@apollo/client';

const {shareAccessIdentifier} = window;

const SHARE_ACCESS_IDENTIFIER_KEY = 'X-Share-Access-Identifier';

export function shareAccessSetter(
  this: JQueryAjaxSettings,
  xhr: XMLHttpRequest,
  settings: JQueryAjaxSettings
): void {
  if (shareAccessIdentifier == null) {
    return;
  }
  // Avoids sending on PUT and DELETE just to be safe.
  if (!/^(PUT|DELETE|HEAD|OPTIONS|TRACE)$/i.test(settings.type!) && !this.crossDomain) {
    xhr.setRequestHeader(SHARE_ACCESS_IDENTIFIER_KEY, shareAccessIdentifier);
  }
}

export function createShareAccessApolloLink(): ApolloLink {
  return new ApolloLink((operation, forward) => {
    if (shareAccessIdentifier != null) {
      operation.setContext({
        headers: {
          [SHARE_ACCESS_IDENTIFIER_KEY]: shareAccessIdentifier,
        },
      });
    }
    return forward(operation);
  });
}

export function getActiveShareLinkItemId(): string | null {
  // Get the value from window for each invocation so tests can manipulate the value.
  const {shareAccessIdentifier} = window;
  if (shareAccessIdentifier == null) {
    return null;
  }
  return shareAccessIdentifier.split(':')[1];
}

export function getActiveShareLinkShareId(): string | null {
  const {shareAccessIdentifier} = window;
  if (shareAccessIdentifier == null) {
    return null;
  }
  return shareAccessIdentifier.split(':')[0];
}
